import React from "react";

import { MenuItem } from "@mui/material";

import FilterAltIcon from "@mui/icons-material/FilterAlt";

import Menu, { MenuProps } from "../Menu/Menu";

export type FilterMenuProps = MenuProps & {};

const FilterMenu = ({ children, ...others }: FilterMenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Menu
        onClose={handleClose}
        anchorEl={anchorEl}
        isIconButton={true}
        iconButtonIcon={<FilterAltIcon />}
        sx={{
          "& .MuiPaper-root": {
            marginTop: "8px",
          },
        }}
        {...others}
        open={open}
        handleClick={handleClick}>
        {children}
      </Menu>
    </>
  );
};

FilterMenu.MenuItem = MenuItem;
export default FilterMenu;
